import script from "./DashboardMapBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardMapBlock.vue?vue&type=script&setup=true&lang=js"

import "./DashboardMapBlock.vue?vue&type=style&index=0&id=6139a51c&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6139a51c"]])

export default __exports__